import { render, staticRenderFns } from "./el-collectGroup.vue?vue&type=template&id=8c84d944&scoped=true"
import script from "./el-collectGroup.vue?vue&type=script&lang=js"
export * from "./el-collectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c84d944",
  null
  
)

export default component.exports